<template>
  <div>
    <section class="banner_title">
      <div class="">
        <!-- <a :href="link_href"
           class="pl-tag">
          <slot name="tag"></slot>
        </a> -->
        <h1 class="pl-h1">
          <slot name="title"></slot>
        </h1>
        <p>
          <slot name="subtitle"></slot>
        </p>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  props: ['link_href'],
  mounted () {
    console.log(this.link_href)
  }
}
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
}
.pl-tag {
  font-size: 27px;
  font-weight: 500;
  text-transform: uppercase;
  color: #939589;
  margin-bottom: 10px;
  text-decoration: none;
}

.pl-h1 {
  font-weight: 700;
  font-size: 40px;
  line-height: 60px;
}

.banner_title {
  padding: 120px 0 120px;
  text-align: center;
}

p {
  font-size: 22px;
  line-height: 32px;
  width: 90%;
  text-align: center;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  margin: 20px 0 16px 0;
}

@media (max-width: 544px) {
  .pl-tag {
    font-size: 16px;
    font-weight: 500;
  }
  .pl-h1 {
    font-size: 42px;
    line-height: 54px;
  }

  .banner_title {
    padding: 40px 30px 40px;
    margin-top: 25px;
  }

  p {
    font-size: 20px;
    line-height: 24px;
  }
}

@media (max-width: 767px) and (orientation: landscape) {
  .pl-tag {
    font-size: 21px;
    font-weight: 500;
  }
  .pl-h1 {
    font-size: 42px;
    line-height: 64px;
  }
  p {
    font-size: 20px;
  }
}

@media (min-width: 1200px) {
  .pl-tag {
    font-size: 32px;
    font-weight: 500;
  }
  .pl-h1 {
    font-size: 64px;
    line-height: 76px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Article/bannertitle.vue